import { SITE } from '@/app/constants';

// 反馈链接
export const FEEDBACK_CHINA_URL = 'https://shengshu.feishu.cn/share/base/form/shrcnMX4EgJsJN0bjXFwID0LzKe';
// 反馈链接
export const FEEDBACK_GLOBAL_URL = 'https://shengshu.feishu.cn/share/base/form/shrcnYdKU2rGpxRDzNLhL2fqM9g';

export const getFeedBackUrl = () => {
  return SITE === 'global' ? FEEDBACK_GLOBAL_URL : FEEDBACK_CHINA_URL;
};
